// Satellite API wrapper - bridges LeftPanel components to root MissionService
import MissionService from '../../../../service/MissionService';
import MissionModelService from '../../../../service/MissionModelService';

export const getSatelliteGroups = (mission_id: string, scenario_id: string) =>
  MissionService.getSatelliteGroups(mission_id, scenario_id);

export const getAllSatelliteGroupOrbit = (mission_id: string, scenario_id: string) =>
  MissionService.getAllSatelliteGroupOrbit(mission_id, scenario_id);

export const createSatelliteGroup = (mission_id: string, scenario_id: string, data: any) =>
  MissionService.createSatelliteGroup(mission_id, scenario_id, data);

export const editSatelliteGroup = (mission_id: string, scenario_id: string, groupId: string, data: any) =>
  MissionService.editSatelliteGroup(mission_id, scenario_id, groupId, data);

export const cloneMissionSimulationGroup = (mission_id: string, scenario_id: string, groupId: string) =>
  MissionService.cloneMissionSimulationGroup(mission_id, scenario_id, groupId);

export const deleteMissionSimulationGroup = (mission_id: string, scenario_id: string, groupId: string) =>
  MissionService.deleteMissionSimulationGroup(mission_id, scenario_id, groupId);

export const deleteMissionSimulationGroups = (mission_id: string, scenario_id: string, groupIds: string[]) =>
  MissionService.deleteMissionSimulationGroups(mission_id, scenario_id, groupIds);

export const uploadTle = (mission_id: string, scenario_id: string, data: FormData) =>
  MissionModelService.uploadTle(mission_id, scenario_id, data);
